import { render, staticRenderFns } from "./LectOrPracChip.vue?vue&type=template&id=3c7bfde4"
import script from "./LectOrPracChip.vue?vue&type=script&lang=js"
export * from "./LectOrPracChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports